import { transports, createLogger } from 'winston'

const logger = createLogger({
    level: process.env.LOG_LEVEL || 'info',
    transports: [new transports.Console()]
})

export default logger
